exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2sMbLJSEUXTQBiKOfxaOjm{font-weight:400;color:\"[theme:neutralPrimary, default:#323130]\"}._2bOxM8d-db4R1VXW5VoMyk{display:-webkit-box;display:-ms-flexbox;display:flex}._3LFf0xdmABzZ4G2HSLa82k{color:#e81123;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir] ._3LFf0xdmABzZ4G2HSLa82k{padding-top:2px}html[dir=ltr] ._3LFf0xdmABzZ4G2HSLa82k{margin-right:6px}html[dir=rtl] ._3LFf0xdmABzZ4G2HSLa82k{margin-left:6px}", ""]);
// Exports
exports.locals = {
	"locationDeclinedString": "_2sMbLJSEUXTQBiKOfxaOjm",
	"autoRoomBookingStatusContainer": "_2bOxM8d-db4R1VXW5VoMyk",
	"errorIconContainer": "_3LFf0xdmABzZ4G2HSLa82k"
};